module.exports = __webpack_public_path__ + "f5fb34b51392b755dd79cd62885dc889.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/leak.png
// module id = 52
// module chunks = 1